const REMEMBER_LOGIN_KEY = 'rememberLogin'
const REMEMBERED_USERNAME_KEY = 'rememberedUsername'

export function getRememberLoginPreference () {
  try {
    return window.localStorage.getItem(REMEMBER_LOGIN_KEY) === '1'
  } catch (error) {
    return false
  }
}

export function getRememberedUsername () {
  if (!getRememberLoginPreference()) return null

  try {
    return window.localStorage.getItem(REMEMBERED_USERNAME_KEY) || null
  } catch (error) {
    return null
  }
}

export function clearRememberLogin () {
  try {
    window.localStorage.removeItem(REMEMBER_LOGIN_KEY)
    window.localStorage.removeItem(REMEMBERED_USERNAME_KEY)
  } catch (error) {}
}

export async function persistRememberLogin (username, password) {
  try {
    window.localStorage.setItem(REMEMBER_LOGIN_KEY, '1')
    window.localStorage.setItem(REMEMBERED_USERNAME_KEY, username)
  } catch (error) {}

  if (window.PasswordCredential && password) {
    try {
      const credential = new window.PasswordCredential({
        id: username,
        password,
        name: username,
      })
      await window.navigator.credentials.store(credential)
    } catch (error) {
      // El browser puede rechazar el store; username + preferencia ya quedaron guardados
    }
  }
}

export async function tryLoadBrowserCredentials () {
  if (!window.PasswordCredential && !window.FederatedCredential) {
    return null
  }

  try {
    const credential = await window.navigator.credentials.get({
      password: true,
      federated: {
        providers: ['https://accounts.google.com'],
      },
      mediation: 'optional',
    })

    if (credential !== null && credential.type === 'password') {
      return {
        username: credential.id,
        password: credential.password,
      }
    }
  } catch (error) {}

  return null
}
